export enum MessageDataSenderType {
  ActualAgent = 'actualAgent',
  OtherAgent = 'otherAgent',
  Bot = 'bot',
  Customer = 'customer'
}
